import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { useIntl } from 'react-intl'

interface SummaryShipmentOptionProps {
    shippingCost?: number
    freeShippingType: 'park' | 'email'
}

const SummaryShipmentOption = ({
    shippingCost,
    freeShippingType,
}: SummaryShipmentOptionProps) => {
    const { formatMessage } = useIntl()

    return (
        <Box isFullWidth direction="row" justify="space-between">
            {!shippingCost ? (
                <>
                    <Text variant="bodySmall" color="grayscale_900">
                        {freeShippingType === 'park' &&
                            formatMessage({
                                id: 'global.summary.pickup_park',
                                defaultMessage: 'Odbiór w parku',
                            })}
                        {freeShippingType === 'email' &&
                            formatMessage({
                                id: 'global.summary.receive_email',
                                defaultMessage: 'E-mail',
                            })}
                    </Text>

                    <Text variant="bodySmall" color="primary_500">
                        0 PLN
                    </Text>
                </>
            ) : (
                <Box
                    isFullWidth
                    direction="row"
                    align="center"
                    justify="space-between"
                >
                    <Text variant="bodySmall" color="grayscale_900">
                        {formatMessage({
                            id: 'global.summary.pickup_courier',
                            defaultMessage: 'Wysyłka kurierem',
                        })}
                    </Text>
                    <Text variant="bodySmall" color="primary_500">
                        {formatPrice(shippingCost, true)}
                    </Text>
                </Box>
            )}
        </Box>
    )
}

export default SummaryShipmentOption
